import React from 'react';
import Navbar from '../Navbar';
import HeroSlide from '../HeroSlide';
import MovieDetails from '../MovieDetails';
import TvDetails from '../TvDetails';
import Footer from '../Footer';

const Home = () => {
  return (
    <div className="bg-black text-white">
      <Navbar />
      <HeroSlide />
      <MovieDetails trending />
      <MovieDetails cardMovies />
      <TvDetails trending />
      <TvDetails cardTv />
      <Footer />
    </div>
  );
};

export default Home;
